module.exports = __webpack_public_path__ + "static/media/c-low-sugar.1fc6e950.jpg";